import React, { useLayoutEffect } from 'react'
import PropTypes from 'prop-types'
import { usePageHeader } from 'contexts/PageHeaderContext'

/**
 * Registers page title/subtitle/actions in the white app header via context.
 * Does not render title/subtitle in the page body.
 */
const PageHeader = ({ title, subtitle, actions, className, children }) => {
	const { setPageHeader, clearPageHeader } = usePageHeader()

	useLayoutEffect(() => {
		setPageHeader({ title, subtitle, actions })
		return () => clearPageHeader()
	}, [title, subtitle, actions, setPageHeader, clearPageHeader])

	if (!children) {
		return null
	}

	return <div className={className}>{children}</div>
}

PageHeader.propTypes = {
	title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
	subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	actions: PropTypes.node,
	className: PropTypes.string,
	children: PropTypes.node,
}

export default PageHeader
